/* eslint-disable */

import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { voterAbi } from "@/domains/abis"

import type { TransactionReturnType } from "../types"
import { simulatedTransaction } from "../simulated-transaction"

type ClaimAllNftBribesProps = {
  account: Address
  chainId: number
  config: Config
  voterAddress: Address
  // gauges: Array<Address>
  // gtokens: Array<Array<Address>>
  bribes: Array<Address>
  btokens: Array<Array<Address>>
  tokenId: number
}
// this is the same as claimAllLpReward, but for NFT bribes

export const claimAllNftBribes = async ({
  account,
  chainId,
  config,
  voterAddress,
  // gauges,
  // gtokens,
  bribes,
  btokens,
  tokenId,
}: ClaimAllNftBribesProps): Promise<TransactionReturnType> => {
  try {
    // we can optimize this, there is a claim bribes function...
    // lets print out what the old UI used to send and what this ACTUALLY needs to send

    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: voterAbi as Abi,
        account,
        address: voterAddress,
        args: [[], [], bribes, btokens, tokenId],
        chainId,
        functionName: "claimEverything",
      },
    })
    return result
  } catch (error: any) {
    console.error("claimAllNftBribes", error)
    return { success: false, error: error.message, code: error.code }
  }
}
